import LoginLogic from "../Application/Login.logic";
import LogoutLogic from "../Application/Logout.logic";
import {setUserModel} from "../../User/Infrastructure/User.reducer";
import SignUpLogic from "../Application/SignUp.logic";
import store from "../../Redux/store";

export async function Login(email, password) {
  try{
    const login = await LoginLogic(email, password);
    store.dispatch( setUserModel(login.username) );
    localStorage.setItem("userid", login.username);
    return {valid: true, info: login};
  }catch(error){
    return {valid: false, info: error};
  }
}

export async function Logout() {
  return LogoutLogic();
}

export async function UserSignUp(info){
  return SignUpLogic(info);
} 